import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryInfiniteFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { AuthenticationCredentialsResult, AuthenticationCredentialSurface } from "./types";

export const getAuthenticationCredentials = reactQueryInfiniteFetcherAdapter(
  "/app_settings/authentication_credentials",
  (
    signal: AbortSignal,
    [appGroupId, domain, surface, search, credentialId]: [
      string,
      string,
      AuthenticationCredentialSurface,
      string,
      string,
    ],
    start: number | undefined
  ): Promise<AuthenticationCredentialsResult> =>
    fetch(
      "/app_settings/authentication_credentials",
      "GET",
      {
        app_group_id: appGroupId,
        surface,
        limit: 100,
        start: start ?? 0,
        query: serializeQueryObjects({
          ...(domain ? { domain } : {}),
          ...(search ? { name: search } : {}),
          ...(credentialId ? { id: credentialId } : {}),
        }),
      },
      { signal },
      { propagateFetchRequestError: false }
    )
);
